import SettingsIcon from 'material-ui-icons/Settings';
import IconButton from 'material-ui/IconButton';
import Menu, { MenuItem } from 'material-ui/Menu';
import { withStyles } from 'material-ui/styles';
import { lighten } from 'material-ui/styles/colorManipulator';
import React from 'react';

/**
 * InvoicesTableMenu
 */
const menuStyles = theme => ({
    root: {
        backgroundColor: lighten(theme.palette.secondary.light, 0.85)
    }
});

class InvoicesTableMenu extends React.Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            anchorEl: null
        };
    }

    handleClick = event => {
        this.setState({ anchorEl: event.currentTarget });
    };

    handleClose = () => {
        this.setState({ anchorEl: null });
    };

    render() {
        const { options } = this.props;
        const { anchorEl } = this.state;
        return (
            <div>
                {options != undefined ? (<div>
                    <IconButton aria-label="More"
                        aria-owns={anchorEl ? 'long-menu' : null}
                        aria-haspopup="true" onClick={this.handleClick}>
                        <SettingsIcon />
                    </IconButton>
                    <Menu
                        id="long-menu"
                        anchorEl={anchorEl}
                        open={Boolean(anchorEl)}
                        onClose={this.handleClose}>
                        {options.map(option => (
                            <MenuItem key={option}
                                onClick={(event) => {
                                    if (this.props.actionhandler) {
                                        this.props.actionhandler(this.props.reservation, option);
                                    }
                                    this.handleClose();
                                }}>
                                {this.props.labels ? this.props.labels[option] : option}
                            </MenuItem>
                        ))}
                    </Menu></div>) : ''}
            </div>
        );
    }
}

export default withStyles(menuStyles)(InvoicesTableMenu);


// WEBPACK FOOTER //
// ./src/components/Invoices/Table/InvoicesTableMenu.js